/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";
import Appointment from "./Appointment";
import Form from "./Form";
import ItemMenu from "./ItemMenu";
import Shop from "./Shop";


// The name must be the component class name 'NameOfComponent'=NameOfComponent
const list = [
    {
        name: 'Appointment',
        component: Appointment
    },
    {
        name: 'Form',
        component: Form
    },
    {
        name: 'ItemMenu',
        component: ItemMenu
    },
    {
        name: 'Shop',
        component: Shop
    }
];

export function getCustomComponentObject(name) {
    let find = list.find(c => c.name === name);
    if (find)
        return new find.component();
    return null;
}

export function createCustomComponentElement(col, name, style) {
    if(!name)
        return null;
    let find = list.find(c => c.name === name);
    if (find)
        return React.createElement(find.component, { col: col, style: style }, null);
    return null;
}

export default list;